{
  "features": {
    "filePreview": {
      "measurements": {
        "label": "Målte figurer på denne siden",
        "show": "Vis målinger",
        "unlabelled": "Uten navn",
        "count": "{count, plural, one {# figur} other {# figurer}}",
        "measured": "Målt: {total}"
      }
    },
    "scopeBreakdown": {
      "title": "Omfangsoversikt",
      "frame": {
        "none": "Volve leser alle anbudsfilene inn i et ark etter din standard",
        "running": "Skriver omfangsoversikten",
        "failed": "Forrige kjøring mislyktes",
        "partial": "Delvis skrevet. Oppdater for å fullføre",
        "ready": "Omfangsoversikten etter din standard, som et ark",
        "unavailable": "Oppdateres"
      },
      "page": {
        "no-documents": {
          "title": "Ingen dokumenter å lese",
          "description": "Last opp anbudsdokumentene, eller prøv dem som ikke kunne analyseres på nytt.",
          "action": "Gå til filer"
        },
        "preparing": {
          "title": "Klargjør dokumentene",
          "description": "Du kan kjøre omfangsoversikten når anbudsdokumentene er analysert."
        },
        "empty": {
          "title": "Ingen omfangsoversikt ennå",
          "description": "Volve leser alle anbudsfilene og skriver omfangsoversikten som et ark, etter standarden du velger."
        },
        "running": {
          "title": "Starter kjøringen",
          "description": "Arket vises her når kjøringen oppretter det, og fylles etter hvert som Volve leser filene."
        },
        "unavailable": {
          "title": "Omfangsoversikten oppdateres",
          "description": "Den nye omfangsoversikten er ikke tilgjengelig ennå. Prøv igjen etter oppdateringen."
        },
        "failed": {
          "title": "Kunne ikke laste dokumentstatus",
          "description": "Prøv igjen for å sjekke om dokumentene er klare.",
          "action": "Prøv igjen"
        }
      },
      "runAlert": {
        "failed": {
          "title": "Forrige kjøring mislyktes",
          "run": "Omfangsoversikten stoppet før den ble ferdig. Prøv igjen med de lagrede valgene.",
          "update": "Det lagrede arbeidet beholdes. Prøv igjen for å fortsette omfangsoversikten.",
          "reasons": {
            "time_limit": "Kjøringen nådde tidsgrensen før den skrev en rad.",
            "allowance": "Kjøringen brukte opp modellkallene sine før den skrev en rad.",
            "answer_refused": "Svaret fra kjøringen gjorde ikke rede for alle anbudsfilene, og den stoppet før den skrev en rad.",
            "agent_failed": "Agenten stoppet før den skrev en rad.",
            "no_standard": "Kjøringen angir ingen struktur. Velg en og kjør på nytt.",
            "expired": "Kjøringen sluttet å svare og ble avsluttet.",
            "crashed": "Kjøringen stoppet på grunn av en intern feil.",
            "invalid_result": "Kjøringen stoppet fordi et resultat ikke kunne behandles.",
            "invalid_source": "Påkrevde dokumenter må være ferdig indeksert før kjøringen kan starte."
          }
        },
        "partial": {
          "title": "Forrige kjøring ble ikke ferdig med alt",
          "description": "{count, plural, =0 {Inndelingen stoppet før den ble ferdig. Oppdater for å fortsette fra det lagrede arbeidet.} one {# fil kunne ikke leses. Oppdater for å prøve igjen. Det lagrede arbeidet beholdes.} other {# filer kunne ikke leses. Oppdater for å prøve igjen. Det lagrede arbeidet beholdes.}}",
          "notRead": "Ikke lest"
        },
        "running": {
          "run": "Volve leser kontrakten. Kravene vises etter hvert som de finnes; pakkene kommer når Volve er ferdig.",
          "update": "Volve oppdaterer inndelingen. Du kan jobbe videre; endringene vises når Volve er ferdig."
        }
      },
      "run": {
        "run": "Start omfangsoversikt",
        "update": "Oppdater",
        "runDescription": "Volve leser kravene og foreslår arbeidspakker. Du velger beskrivelsesmåte per pakke etterpå.",
        "updateDescription": "Volve leser nye eller endrede dokumenter. Dine pakkevalg og endringer beholdes.",
        "startNew": "Start en ny omfangsoversikt",
        "startNewDescription": "Lag en ny omfangsoversikt fra konkurransegrunnlaget. Sendte pakker beholdes uendret.",
        "structure": "Hva skal styre inndelingen?",
        "structures": {
          "library": {
            "title": "En standard",
            "description": "Volve leser standarden og bruker kapitlene som fag og pakker."
          },
          "volve": {
            "title": "Volves mal",
            "description": "Volves generelle pakkeinndeling."
          },
          "template": {
            "title": "Egen mal",
            "description": "Firmaets egen inndeling, lastet opp eller fra kunnskapsbasen."
          },
          "tender_bill": {
            "title": "Anbudets egen prisliste",
            "description": "Byggherrens poster, koder og rekkefølge."
          }
        },
        "standards": "Standarder",
        "uploadStandard": "Last opp standard eller mal",
        "standardPreparing": "Klargjør standarden. Den velges automatisk når den er klar.",
        "standardFailed": "Standarden kunne ikke klargjøres. Prøv igjen eller fortsett uten den.",
        "retryStandard": "Prøv klargjøring på nytt",
        "skipStandard": "Fortsett uten denne standarden",
        "standardsDescription": "Velg en teknisk standard, et beskrivelsessystem, en håndbok eller en mal. Opplastinger lagres i biblioteket for gjenbruk.",
        "noStandards": "Ingen standarder er klare ennå. Last opp en standard eller mal for å komme i gang.",
        "instructions": "Instruksjoner",
        "instructionsPlaceholder": "For eksempel: behold byggherrens nummerering og ta med de refererte vedleggene.",
        "instructionsUpdatePlaceholder": "Beskriv hva de nye eller endrede dokumentene tilfører.",
        "instructionsDescription": "Valgfritt. Volve følger dem i tillegg til strukturen.",
        "files": "Anbudsfiler",
        "noFiles": "Anbudet har ingen filer ennå. Last opp malen.",
        "upload": "Last opp",
        "pickStructure": "Velg en struktur",
        "pickStandard": "Velg minst én kunnskapsbase som inneholder standarden",
        "pickFiles": "Velg minst én anbudsfil til malen",
        "refused": {
          "preparing": "Anbudets dokumenter klargjøres fortsatt. Prøv igjen når de er klare.",
          "noDocuments": "Anbudet har ingen dokumenter ennå. Last dem opp først.",
          "noSheet": "Det finnes ikke noe ark å oppdatere. Start et nytt ark i stedet."
        },
        "genericError": "Det oppsto en feil, vennligst prøv igjen senere",
        "retry": "Prøv igjen"
      },
      "outline": {
        "tree": "Koder",
        "search": "Søk kode eller tekst",
        "posts": "Poster",
        "postCount": "{count, plural, one {# post} other {# poster}}",
        "allPackages": "Alle pakker",
        "markers": {
          "inPackage": "I denne pakken",
          "input": "Trenger avklaring",
          "assumed": "Har antakelser",
          "interface": "Grensesnitt eller overlapp",
          "empty": "Tom kode",
          "orienting": "Orienterende tekst"
        },
        "states": {
          "stated": "Oppgitt i dokumentene",
          "assumed": "Antatt verdi",
          "input": "Trenger avklaring",
          "unsourced": "Ingen kilde"
        },
        "expand": "Utvid",
        "collapse": "Skjul",
        "noMatches": "Ingen koder eller rader passer",
        "empty": "Arket har ingen omfangsrader ennå",
        "openSource": "Åpne kilde",
        "assign": "Tildel",
        "move": "Flytt",
        "moveToCode": "Flytt til kode",
        "chapterEnd": "Kapittelet, nederst",
        "package": "Pakke",
        "discipline": "Fag",
        "exclude": "Ekskluder",
        "include": "Ta med igjen",
        "excluded": "Ekskludert",
        "task": "Oppgave",
        "quotePage": "s. {page}",
        "flagsAssumptions": "{count, plural, one {# antakelse} other {# antakelser}}",
        "flagsInputs": "{count, plural, one {# trenger avklaring} other {# trenger avklaring}}",
        "legendLines": "Rader",
        "noValue": "—",
        "sourceCount": "{count, plural, one {# kilde} other {# kilder}}",
        "assumed": "Antatt",
        "introduction": "Innledning",
        "orienting": {
          "label": "Orienterende tekst",
          "hint": "Anbudsvilkår som påvirker prisene under; prises ikke selv.",
          "more": "+{count}",
          "showAll": "Vis alle {count}",
          "showLess": "Vis færre",
          "add": "Legg til vilkår",
          "addPlaceholder": "Vilkåret, med anbudets ord",
          "addSave": "Legg til",
          "cancel": "Avbryt",
          "addedByYou": "Lagt til av deg",
          "comment": "Kommenter",
          "restore": "Gjenopprett",
          "marker": "{count, plural, one {# orienterende tekst} other {# orienterende tekster}}",
          "recheck": "Vilkår endret · Kontroller postene",
          "recheckIntro": "Den orienterende teksten under {heading} i fanen {tab} er endret. Kontroller postene under den, og juster omfang og mengder der endringen påvirker dem:",
          "changes": {
            "added": "Lagt til",
            "excluded": "Utelatt",
            "restored": "Gjenopprettet"
          }
        },
        "applies": {
          "label": "Gjelder her",
          "hint": "Arvet fra overskriftene over. Rediger ved overskriften.",
          "fromGroup": "fra {code} · denne gruppen",
          "fromTrade": "fra {code} · alle poster",
          "goToHeading": "Gå til overskriften",
          "showMore": "Vis {count} til",
          "showLess": "Vis færre"
        },
        "edit": {
          "confirm": "Bekreft",
          "edit": "Rediger",
          "save": "Lagre",
          "cancel": "Avbryt",
          "number": "Ikke et tall",
          "option": "Ikke et av valgene",
          "remeasure": "Mål posten på nytt",
          "remeasureInstruction": "Mål mengden for post {post} i fanen {tab} på nytt: {field} er nå {value}."
        },
        "suggestedChanges": "Foreslåtte endringer",
        "suggestedField": "Forslag til {field}",
        "clearSuggestedValue": "Tøm denne verdien",
        "acceptSuggestion": "Godta forslag",
        "dismissSuggestion": "Behold min verdi",
        "suggestionCount": "{count, plural, one {# foreslått endring} other {# foreslåtte endringer}}"
      },
      "openCurrentSheet": "Åpne gjeldende ark",
      "beta": "Beta",
      "overview": {
        "intro": "Velg utførelse og beskrivelsesmåte for hver pakke. Valgene kan endres senere.",
        "standardStructure": "Inndeling etter {standard}",
        "empty": "Ingen krav er hentet ut ennå. Start en omfangsoversikt for å lage arbeidspakker.",
        "suggestions": "{count} forslag",
        "uncertain": "{count, plural, one {# usikker plassering} other {# usikre plasseringer}}",
        "conflicts": "{count, plural, one {# konflikt} other {# konflikter}}",
        "allRequirements": "Alle krav",
        "newPackage": "Ny pakke",
        "back": "Tilbake til pakkene",
        "package": "Pakke",
        "requirements": "Krav",
        "execution": "Utførelse",
        "method": "Beskrivelsesmåte",
        "status": "Status",
        "selectAll": "Velg alle pakker",
        "selectPackage": "Velg {name}",
        "expand": "Vis krav i {name}",
        "choose": "Velg…",
        "selfPerform": "Egenproduksjon",
        "subcontract": "Underentreprise",
        "packageRequirements": "Alle krav i pakken",
        "selected": "{count} valgt",
        "clear": "Fjern valg",
        "name": "Pakkenavn",
        "create": "Opprett pakke",
        "noRequirements": "Ingen krav i pakken.",
        "saveFailed": "Kunne ikke lagre pakkevalgene. Prøv igjen.",
        "sent": "Sendt v{version}",
        "next": {
          "requirements": "Neste: sjekk krav",
          "choose-description": "Neste: velg måte",
          "work-pack": "Neste: lag beskrivelse",
          "documents": "Neste: generer pakke",
          "send": "Vis sendt pakke",
          "offers": "Vis tilbud",
          "add-information": "Legg til informasjon",
          "generate": "Generer arbeidspakke",
          "proofread": "Korrekturles",
          "client-posts": "Neste: gjennomgå poster",
          "changes": "Neste: gjennomgå endringer"
        },
        "generateSelected": "Generer beskrivelser ({count})",
        "generateFailed": "{count, plural, one {# pakke kunne ikke settes i kø.} other {# pakker kunne ikke settes i kø.}} Andre godkjente pakker fortsetter.",
        "generateQueued": "Beskrivelser satt i kø",
        "backgroundGeneration": "Genereringen fortsetter i bakgrunnen.",
        "running": {
          "title": "Volve leser kontrakten",
          "description": "Kravene vises her så snart de første er funnet. Pakkene kommer når kjøringen er ferdig."
        }
      },
      "start": {
        "title": "Start en omfangsoversikt",
        "choose": "Velg hva omfangsoversikten skal starte fra.",
        "files": "Byggherrens dokumenter",
        "pages": "{count, plural, one {# side} other {# sider}}",
        "profile": "Beskrivelsesstandard",
        "chooseProfile": "Velg en lagret profil…",
        "methods": "Tilgjengelige metoder: {names}",
        "executionPending": "Lesing av utførelsesentrepriser er ikke tilgjengelig ennå. Dette valget starter ingen kjøring.",
        "client_posts": {
          "title": "Bryt ned en utførelsesentreprise",
          "description": "Byggherren har skrevet kapitler og {lines}. Volve beholder strukturen og foreslår en arbeidspakke per kapittel."
        },
        "requirements": {
          "title": "Bryt ned en totalentreprise",
          "description": "Volve leser kravene og fordeler dem på arbeidspakker. Velg beskrivelsesmåte per pakke etterpå."
        },
        "lines": "prislinjer"
      },
      "detail": {
        "search": "Søk i krav",
        "selected": "{count} valgt",
        "include": "Inkluder",
        "exclude": "Utelat",
        "move": "Flytt til",
        "saveFailed": "Kunne ikke lagre",
        "status": "Status",
        "viewSource": "Vis kilde",
        "citationScope": "Vis i kilden",
        "contractScope": "Med i kontrakten",
        "scopeHint": "Se omfanget i kilden før du lagrer. Kontraktsomfanget bestemmer hva som tas med i arbeidspakken.",
        "saveScopes": "Lagre omfang",
        "sourceRecord": "Kildeoppføring",
        "page": "Side {page}",
        "empty": "Ingen krav",
        "levels": {
          "exact": "Nøyaktig tekst",
          "paragraph": "Avsnitt",
          "section": "Delkapittel",
          "chapter": "Kapittel",
          "document": "Hele dokumentet"
        }
      },
      "package": {
        "missing": "Ikke tilgjengelig",
        "version": "Versjon {version}",
        "steps": "Steg for arbeidspakken",
        "continue": "Fortsett",
        "chooseTitle": "Hvordan skal pakken beskrives?",
        "chooseHint": "Velg én. Du kan endre det senere.",
        "contractStandard": "Kontraktsstandard",
        "choose": "Velg",
        "ownTerms": "Last opp egne avtalevilkår",
        "lineStandards": "Standarder for {lines}",
        "lines": "prislinjer",
        "line": "prislinje",
        "upload": "Last opp dokumenter",
        "askSuggestion": "Be Volve om forslag",
        "saveFailed": "Kunne ikke lagre",
        "notGenerated": "Generer en beskrivelse fra kravene i pakken.",
        "noPosts": "Ingen {lines} ble skrevet. Legg til en {line}, eller en standard som dekker kravene.",
        "introduction": "Innledende tekst",
        "noIntroduction": "Ingen innledning ennå",
        "edit": "Rediger",
        "save": "Lagre",
        "conditions": "Rammebetingelser og fellesdeler",
        "missingDocument": "Referert til, men mangler: {name}",
        "sourceFile": "Velg kildefil",
        "mapQuantities": "Foreslå kobling av mengder",
        "apply": "Bruk",
        "rigging": "Rigging og drift",
        "blankLine": "Ny tom {line}",
        "code": "Kode",
        "title": "Tittel",
        "quantity": "Mengde",
        "unit": "Enhet",
        "remove": "Fjern",
        "uncovered": "Krav uten prislinje: {count}",
        "withVolve": "Legg til med Volve",
        "instruction": "Beskriv hva de nye prislinjene skal dekke",
        "draft": "Foreslå prislinjer",
        "acceptDrafts": "Godta {count} forslag",
        "deliveryMatrix": "Leveranseansvar",
        "removedLines": "Fjernede prislinjer",
        "undo": "Angre",
        "editLine": "Rediger {line}",
        "summary": "Sammendrag",
        "location": "Lokalisering",
        "clientOriginal": "Oppdragsgivers originaltekst",
        "history": "Intern endringshistorikk",
        "method": {
          "performance": "Send oppdragsgivers krav med original ordlyd, sammendrag og leveransematrise.",
          "itemised": "Generer {lines} etter valgt standard, med mengder og tilknyttede krav."
        },
        "fit": {
          "performance": "Passer når underentreprenøren har ansvar for å utvikle løsningen.",
          "itemised": "Passer når løsningen er bestemt og priser skal sammenlignes linje for linje."
        },
        "publicationFailed": "Beskrivelsen er lagret, men arket kunne ikke publiseres. Prøv igjen uten å generere på nytt.",
        "previewCode": "Forhåndsvis kode fra valg",
        "regenerateDescription": "Generer ny versjon",
        "assumption": "Antakelse",
        "chooseValue": "Velg en verdi",
        "doneLinking": "Ferdig med kobling",
        "confirmMapping": "Bekreft koblingen før mengden brukes.",
        "workflowUnavailable": "Utsending og tilbudsvurdering er ikke koblet til i denne forhåndsvisningen. Dagens redigerbare pakke er atskilt fra en sendt versjon.",
        "reviewCurrent": "Se gjeldende pakke"
      },
      "delivery": {
        "saveFailed": "Kunne ikke lagre endringene",
        "summary": "Sammendrag av pakken",
        "documents": "Dokumenter i arbeidspakken",
        "undo": "Angre",
        "notRelevant": "Ikke relevant",
        "upload": "Last opp",
        "chooseFile": "Velg en eksisterende fil",
        "noSections": "Profilen har ingen dokumentdeler ennå. Oppdater standardprofilen for å legge dem til.",
        "step": "Steg {step} av {total}",
        "contractStandard": "Kontraktsstandard",
        "execution": "Utførelse",
        "selfPerform": "Egenproduksjon",
        "subcontract": "Underentreprise",
        "format": "Format",
        "original": "Originalformat",
        "missingDocument": "Referert dokument mangler: {name}",
        "generateHint": "Se over filvalgene før arbeidspakken klargjøres.",
        "previewOnly": "Kun forhåndsvisning. Generering av nedlastbare filer er ikke koblet til ennå.",
        "previewReady": "Versjon {version}: {count} filvalg er klargjort.",
        "back": "Tilbake",
        "continue": "Fortsett",
        "previewFiles": "Forhåndsvis filvalg",
        "checkpoints": "Sjekkpunkter fra Volve",
        "handled": "Marker som håndtert",
        "ignore": "Ignorer",
        "noCheckpoints": "Ingen sjekkpunkter for denne versjonen.",
        "documentView": "Dokumentvisning",
        "generateSteps": {
          "0": "Legg til andre dokumenter",
          "1": "Kontraktsstandard",
          "2": "Struktur",
          "3": "Egenproduksjon eller underentreprise",
          "4": "Format per fil",
          "5": "Klargjør arbeidspakken"
        },
        "generateSection": "Forhåndsvis generert del",
        "sectionPreviewOnly": "Kun forhåndsvisning. Generering av deler og PDF-eksport er ikke koblet til ennå.",
        "mergedPreview": "Forhåndsvis samlet arbeidspakke",
        "undoHandled": "Håndtert · angre",
        "clientChangeLog": "Endringslogg mot byggherren",
        "checkpointsPending": "Kontrollpunktene vises når denne versjonen er ferdig generert.",
        "moveUp": "Flytt seksjonen opp",
        "removeFile": "Fjern fil",
        "downloadMerged": "Last ned samlet PDF",
        "progress": {
          "dispatching": "Venter på å starte…",
          "retrying": "Starter filgenereringen på nytt…",
          "writing": "Skriver de valgte filene…",
          "sources": "Henter kildedokumenter…",
          "files": "Lagrer genererte filer…",
          "page_bundle": "Klargjør kildesider og markeringer…",
          "merging": "Setter sammen arbeidspakkens PDF…",
          "complete": "Filene er lagret. Fullfører…"
        },
        "filesReady": "{count} av {total} filer lagret",
        "safeToLeave": "Du kan forlate denne siden. Genereringen fortsetter, og du kan komme tilbake for å se fremdriften.",
        "descriptionMethod": "Beskrivelsesmåte: {method}",
        "changeDescriptionMethod": "Velg beskrivelse",
        "notChosen": "Ikke valgt",
        "invalidPageRange": "Velg hele sider innenfor dokumentet, med første side før eller lik siste side.",
        "generationFailed": "Filgenereringen ble ikke fullført. Prøv igjen.",
        "generateFilesHint": "Generer de valgte filene og en samlet PDF for denne versjonen av arbeidspakken.",
        "snapshotVersion": "Filer fra versjon {version}",
        "fromPage": "Fra side",
        "throughPage": "Til side",
        "generatedDocument": "Generert dokument",
        "viewDocument": "Vis dokument"
      },
      "execution": {
        "lines": "poster",
        "allLines": "Alle {lines}",
        "search": "Søk etter kode eller beskrivelse",
        "code": "Kode",
        "description": "Beskrivelse",
        "chapter": "Byggherrens kapittel",
        "quantity": "Mengde",
        "state": "Kilde",
        "clientOriginal": "Byggherrens original",
        "added": "Lagt til",
        "current": "Gjeldende arbeidspakke",
        "commonPart": "Fellesdel · følger alle arbeidspakker",
        "noLines": "Ingen treff.",
        "changes": "Endringer mot byggherren",
        "changesHint": "Disse endringene følger arbeidspakken. Intern endringshistorikk holdes separat.",
        "noChanges": "Ingen endringer mot byggherren.",
        "changeKinds": {
          "added": "Lagt til",
          "edited": "Endret",
          "moved": "Flyttet",
          "removed": "Fjernet",
          "condition_added": "Tilføyd betingelse"
        },
        "nextPosts": "Neste: gjennomgå {lines}",
        "overviewIntro": "Byggherrens kapitler og poster danner arbeidspakkene. Velg hvordan hver pakke skal utføres."
      },
      "takeoff": {
        "title": "Mengder fra tegninger",
        "instructions": "Omfang som skal måles",
        "measure": "Lag mengder til kontroll",
        "pending": "Måler…",
        "accept": "Bruk valgte mengder",
        "accepted": "Valgte mengder lagret",
        "error": "Kunne ikke lagre mengder",
        "help": "Kontroller beregningene og de markerte tegningene før mengdene brukes i genererte poster.",
        "empty": "Ingen tegningsmengder ennå.",
        "fees": "Kostnad: ${cost} + ${container} for container",
        "selected": "Bruk denne mengden",
        "unmeasured": "Ikke mengdesatt",
        "download": "Last ned {name}"
      },
      "fidelity": {
        "manual": "Manuelt",
        "completeStepFirst": "Fullfør «{step}» først.",
        "confirmRequirements": "Kravene stemmer",
        "sourceDocument": "Kildedokument",
        "allSourceDocuments": "Alle kildedokumenter",
        "overview": "Oversikt",
        "package": "Pakke",
        "packages": "{count, plural, one {# pakke} other {# pakker}}",
        "chapter": "Kapittel",
        "chapters": "{count, plural, one {# kapittel} other {# kapitler}}",
        "requirements": "{count} krav",
        "version": "Versjon {version}",
        "draft": "Utkast",
        "sent": "Sendt",
        "notSent": "Ikke ennå",
        "change": "Endre",
        "next": "Neste: {step}",
        "continue": "Gå videre",
        "approve": "Godkjenn og send",
        "chooseDescription": "Velg beskrivelse",
        "packagePosition": "Pakke {position} av {count}",
        "chapterPosition": "Kapittel {position} av {count}",
        "overviewIntro": "Foreta valg om pakker, utførelse og beskrivelsesform under. Kan fylles ut, endres og tilpasses senere.",
        "emptyPackages": "{count, plural, one {# tom pakke} other {# tomme pakker}}",
        "showEmpty": "Vis tomme pakker",
        "hideEmpty": "Skjul tomme pakker",
        "newLine": "Ny {line}",
        "blankLine": "Tom {line}",
        "blankHint": "Fyll ut feltene selv, i standardens oppsett.",
        "withVolve": "Med Volve",
        "withVolveHint": "Beskriv hva du trenger, legg ved en fil om du vil. Volve lager forslag.",
        "missingQuantity": "Mangler mengde",
        "noRigging": "Ingen riggposter ennå",
        "introduction": "Innledende tekst",
        "generated": "Generert av Volve",
        "regenerate": "Generer på nytt",
        "internalHistory": "Kun internt. Sendes ikke til underentreprenører.",
        "user": "Bruker",
        "field": "Felt",
        "unknownDocument": "Dokument ikke tilgjengelig",
        "packageLocation": "Arbeidspakke",
        "lineLocation": "{line} {number}",
        "suggested": "Volve foreslår",
        "contractHint": "Standarden for kontrakten med underentreprenøren.",
        "standardsHint": "Den valgte standarden er allerede inkludert. Legg bare til andre standarder ved behov.",
        "inheritedStandard": "Allerede inkludert: {name}",
        "chooseKnowledgeBase": "Velg fra kunnskapsbasen",
        "libraryFileCount": "{count, plural, one {# fil} other {# filer}}",
        "uploaded": "Lastet opp",
        "addTenderFiles": "Legg til filer fra anbudet",
        "startHint": "Velg hva omfangsoversikten skal starte fra.",
        "startAction": "Start omfangsoversikt",
        "startDesignHint": "Volve leser kontrakten, finner krav og sorterer dem i arbeidspakker. Du velger hvordan hver pakke beskrives etterpå.",
        "startExecutionHint": "Volve beholder byggherrens kapitler og ordlyd og foreslår én arbeidspakke per kapittel.",
        "outline": "Kontraktens innhold",
        "outlineHint": "Bare kapitler med krav i denne pakken vises.",
        "withoutHeading": "Uten overskrift",
        "noSourceDocument": "Uten kildedokument",
        "citationScope": "Omfang av sitering",
        "contractScope": "Med i kontrakten",
        "source": "Kilde i kontraktsunderlaget",
        "exact": "Eksakt",
        "paragraph": "Avsnitt",
        "section": "Seksjon",
        "chapterLevel": "Kapittel",
        "document": "Dokument",
        "removeAll": "Fjern alle",
        "conditions": "Betingelser",
        "includedCount": "{included} av {count}",
        "otherConditions": "Andre betingelser",
        "documents": "Dokumenter i pakken",
        "summary": "Sammendrag",
        "uploadDocument": "Last opp dokument",
        "generate": "Generer",
        "noDocument": "Ingen dokument ennå",
        "mergedPdf": "Generer sammenslått PDF",
        "facts": "Fakta om pakken",
        "standard": "Standard",
        "sentLabel": "Sendt",
        "responsible": "Ansvarlig",
        "notAssigned": "Ikke tildelt",
        "interfaces": "Grensesnitt",
        "moveDown": "Flytt seksjonen ned",
        "checkpointsTab": "1. Sjekkpunkter fra Volve",
        "reviewTab": "2. Les gjennom hele pakken",
        "checksLeft": "{count, plural, one {# sjekkpunkt igjen} other {# sjekkpunkter igjen}}",
        "checksIntro": "{count, plural, one {# sjekkpunkt} other {# sjekkpunkter}} før pakken godkjennes",
        "showInPack": "Vis i pakken",
        "downloadAll": "Last ned alle",
        "executionIntro": "Én arbeidspakke per kapittel foreslås. Du kan slå dem sammen nå eller senere.",
        "executionTitle": "Beskrivelse og mengdefortegnelse",
        "generateHint": "Sjekk hvem som utfører hver pakke før filene lages.",
        "generateExecution": "Bekreft egenproduksjon / underentreprise",
        "generateFormats": "Velg filformat per fil",
        "generatePackage": "Generer pakke",
        "executionHelp": "Hentet fra oversikten. Bytt pakke i overskriften for å sjekke en annen pakke. Pakker i egenproduksjon blir interne arbeidspakker. Pakker i underentreprise går videre til tilbud.",
        "newLineTitle": "Ny {line} med Volve",
        "lineInstructions": "Hva skal pakkens {lines} dekke?",
        "lineInstructionsHelp": "Påkrevd. Volve lager ikke {lines} uten en beskrivelse fra deg.",
        "optionalFile": "Fil (valgfritt)",
        "alsoUses": "Volve bruker også",
        "previewDrafts": "Du ser forslagene før noe legges til.",
        "close": "Lukk",
        "cancel": "Avbryt",
        "newRun": "Ny omfangsoversikt",
        "company": "Firma",
        "email": "E-post",
        "deadline": "Tilbudsfrist",
        "add": "Legg til",
        "noRecipients": "Ingen mottakere lagt til. Denne forhåndsvisningen sender ikke invitasjoner.",
        "noOffers": "Ingen tilbud mottatt.",
        "total": "Total",
        "coverage": "Dekning",
        "risk": "Største risiko",
        "showMore": "Vis mer",
        "showLess": "Vis mindre",
        "commonParts": "Fellesdeler",
        "unallocated": "Restomfang",
        "removed": "Fjernet",
        "uncoveredLines": "Krav uten {line}: {count}",
        "removedLines": "Fjernede {lines}",
        "selectSource": "Velg et krav for å se kilden.",
        "selectConditionSource": "Velg en betingelse for å se kilden.",
        "requirementsLabel": "Krav",
        "sourceDocuments": "{count, plural, one {# dokument} other {# dokumenter}}",
        "packageStatus": {
          "draft": "Utkast",
          "ready": "Klar",
          "sent": "Sendt",
          "offers_in": "Tilbud mottatt",
          "awarded": "Tildelt",
          "contracted": "Kontrakt inngått"
        },
        "itemCount": "{count} {items}",
        "executionMeta": "{chapters} kapitler · {posts} {items} · lest av Volve fra {files} filer",
        "unpaginated": "Uten sidetall",
        "configureStart": "Hent ut krav",
        "configureStartHint": "Velg hvordan kravene skal fordeles på arbeidspakker.",
        "back": "Tilbake",
        "noSummary": "Ingen sammendrag for denne versjonen.",
        "codeFromChoices": "Standarden setter koden ut fra valgene under.",
        "codeChanges": "Koden endres",
        "codeChoiceUnavailable": "Ingen kodekobling er tilgjengelig for disse valgene i denne versjonen. Eksisterende kode beholdes.",
        "move": "Flytt",
        "sourcePage": "s. {page}",
        "sourcePageRange": "s. {from}–{to}",
        "noCommonParts": "Ingen fellesdeler tilgjengelig.",
        "whatInPack": "Hva skal med i arbeidspakken?",
        "noTenderBill": "Fant ingen prisliste i dokumentene.",
        "foundInStandard": "Funnet i standarden",
        "descriptionMethods": "Beskrivelsesmåter",
        "performanceShort": "Krav til funksjon og ytelse. Leverandøren prosjekterer. Ingen poster.",
        "itemisedShort": "Prisbare poster med kode, felt og mengde.",
        "chooseMethodLater": "Du velger måte for hver pakke etter at du har sett kravene.",
        "standardSummary": "{count, plural, one {# kapittel} other {# kapitler}} i valgte deler · Eksport: {formats}",
        "includeInPack": "Ta med i arbeidspakken",
        "standardOption": "Standard {number}",
        "correctStandard": "Rett opp",
        "commonPartStatus": "Fellesdel",
        "noHistory": "Ingen endringer ennå.",
        "postUpdated": "Posten ble oppdatert",
        "addStandard": "Legg til standard fra biblioteket …",
        "noStandardMatch": "Ingen standard passer",
        "optional": "(valgfritt)",
        "completeStepFirstHint": "Dette steget bygger på steget før. Fullfør det, og kom tilbake hit.",
        "addRecipients": "Legg til mottakere"
      },
      "design": {
        "steps": {
          "label": "Steg",
          "requirements": "Krav",
          "choose-description": "Velg beskrivelse",
          "work-pack": "Arbeidspakke",
          "add-information": "Legg til informasjon",
          "documents": "Dokumenter i arbeidspakken",
          "documentsItemised": "Dokumenter for arbeidspakken",
          "generate": "Generer arbeidspakke",
          "proofread": "Gjennomlesning og tilpasning",
          "send": "Send",
          "offers": "Tilbud",
          "changes": "Endringer mot byggherren",
          "procurement": "Anskaffelse"
        },
        "next": {
          "performance": {
            "requirements": "Velg beskrivelse",
            "work-pack": "Gå videre",
            "documents": "Neste: Generer arbeidspakke",
            "generate": "Gå videre",
            "proofread": "Godkjenn og send",
            "send": "Send"
          },
          "itemised": {
            "requirements": "Velg beskrivelse",
            "work-pack": "Neste: Rammebetingelser",
            "add-information": "Gå videre",
            "documents": "Gå videre",
            "generate": "Gå videre",
            "proofread": "Godkjenn og send",
            "send": "Send"
          },
          "execution": {
            "overview": "Se og rediger poster per kapittel",
            "client-posts": "Neste: informasjon og dokumenter",
            "changes": "Neste: informasjon og dokumenter",
            "add-information": "Neste: arbeidspakke",
            "documents": "Neste: Generer arbeidspakke",
            "proofread": "Godkjenn og gå til anskaffelse",
            "send": "Send"
          }
        },
        "crumbs": {
          "add-information": "Informasjon og dokumenter",
          "documents": "Dokumenter i arbeidspakken",
          "generate": "Arbeidspakke",
          "proofread": "Gjennomlesning",
          "send": "Anskaffelse",
          "offers": "Tilbud",
          "work-pack": "Arbeidspakke",
          "requirements": "Krav",
          "choose-description": "Velg beskrivelse"
        },
        "moreActions": "Flere valg",
        "backToOverview": "Tilbake til oversikten",
        "clientChanges": "Endringer mot byggherren",
        "quantities": "Mengder",
        "regenerate": "Generer ny versjon",
        "workPacks": "{count, plural, one {# arbeidspakke} other {# arbeidspakker}}",
        "chapters": "{count, plural, one {# kapittel} other {# kapitler}}",
        "executionTitle": "{project} – Beskrivelse og mengdefortegnelse",
        "proofreadCrumb": "Gjennomlesning og tilpasning · arbeidspakke versjon {version} · {standard}",
        "chaptersCrumb": "Kapitler",
        "workPackPosition": "Arbeidspakke {position} av {count}",
        "chapterPosition": "Kapittel {position} av {count}",
        "addInformationHint": "Legg til flere opplysninger og rammebetingelser",
        "nothingLeft": "Ingenting igjen å sjekke",
        "exportUnavailable": "Nedlasting av genererte filer er ikke koblet til ennå.",
        "packagesCrumb": "Pakker",
        "itemisedCrumb": "Pakker med {line}beskrivelse",
        "details": "{count, plural, one {# detalj} other {# detaljer}}",
        "previewPack": "Se foreløpig pakke",
        "searchPackage": "Søk i pakkens krav",
        "generateTitle": "{count, plural, one {Lag beskrivelse} other {Lag beskrivelser for # pakker}}",
        "generateAction": "{count, plural, one {Lag beskrivelse} other {Lag beskrivelser (#)}}",
        "missingMethod": "Velg beskrivelsesmåte først for: {names}",
        "frameworkConditions": "Rammebetingelser",
        "clarify": "Avklares",
        "move": "Flytt",
        "delete": "Slett",
        "clearSelection": "Fjern valg",
        "requirementCount": "{count} krav",
        "citationNotes": {
          "manual": "Siteringen viser teksten du har markert selv.",
          "exact": "Sitatet viser bare setningen.",
          "paragraph": "Sitatet viser hele avsnittet rundt kravet.",
          "section": "Sitatet viser hele seksjonen rundt kravet.",
          "chapter": "Sitatet viser hele kapittelet.",
          "document": "Sitatet viser hele dokumentet."
        },
        "contractNotes": {
          "manual": "Teksten du har markert selv tas med i arbeidspakken.",
          "exact": "Bare den markerte setningen tas med i kontrakten.",
          "paragraph": "Hele avsnittet tas med i kontrakten.",
          "section": "Hele seksjonen tas med i kontrakten.",
          "chapter": "Hele kapittelet tas med i kontrakten.",
          "document": "Hele dokumentet tas med i kontrakten."
        },
        "allChecksDone": "Alle sjekkpunkter er gjort",
        "ignored": "Ignorert",
        "done": "Ferdig",
        "reviewMeta": "{project} · Arbeidspakke {name} · versjon {version}",
        "freeText": "fri tekst",
        "today": "I dag {time}",
        "yesterday": "I går {time}",
        "clientPost": "Byggherrens post {number}.",
        "requirementsCovered": "Krav posten dekker",
        "linkRequirement": "Koble krav",
        "unlinkRequirement": "Fjern kravet fra posten",
        "fieldsHint": "Feltene med pil har faste valg fra standarden. Felt uten faste valg skriver du selv.",
        "quantityWithUnit": "Mengde ({unit})",
        "clientOriginal": "Byggherrens originaltekst",
        "clientChangeTracked": "Endringen spores i endringsloggen, siden byggherrens tekst er kontrakten.",
        "history": "Historikk",
        "changed": "endret {changes}",
        "savePost": "Lagre post",
        "editRiggingLine": "Rediger riggpost",
        "quantityPlaceholder": "Mangler mengde",
        "quantityMissingHint": "Mengden står ikke i underlaget. Angi den før du sender.",
        "enterQuantity": "Angi mengde",
        "enterQuantityShort": "Angi",
        "assumedHint": "Antatt av Volve. Bekreft eller endre i posten.",
        "chapterLabel": "Kapittel",
        "riggingPosts": "Riggposter",
        "riggingSelected": "{selected} av {count} valgt",
        "riggingFrom": "Fra {chapter}",
        "riggingIncluded": "{count} {lines} tatt med i denne arbeidspakken",
        "editShort": "Rediger",
        "riggingCount": "{count, plural, one {# riggpost} other {# riggposter}}",
        "riggingHint": "Ingen riggposter er lagt til i denne pakken.",
        "chooseRigging": "Velg riggposter",
        "blankLine": "Tom {line}",
        "actions": "Handlinger",
        "showLine": "Vis detaljer for {line}",
        "editLine": "Rediger {line}",
        "addedMark": "Lagt til",
        "addLine": "Legg til {line}",
        "addedHint": "Nye {lines} merkes «Lagt til».",
        "uncoveredLabel": "Krav uten {line}:",
        "uncoveredNone": "Alle krav i pakken har en {line}.",
        "uncoveredSome": "Disse kravene er ennå ikke dekket av en {line}.",
        "newLineExecutionHint": "{name} · nye poster merkes «Lagt til» mot byggherren",
        "fileLabel": "Fil",
        "optional": "(valgfritt)",
        "pages": "{count, plural, one {# side} other {# sider}}",
        "removeFile": "Fjern fil",
        "fileHint": "PDF, Excel, Word eller bilde. Et tilbud, en mengdeliste eller egne notater.",
        "linesInChapter": "{count} {lines} i {name}",
        "alsoUsesHint": "Volve søker selv i det som trengs.",
        "alsoUsesExecutionHint": "Volve søker selv i det som trengs. Nye poster føres i endringsloggen mot byggherren.",
        "makeSuggestions": "Lag forslag",
        "method": "Beskrivelsesmåte",
        "subcontractFor": "Bruk {name} hvis hovedkontrakten er {main}.",
        "chooseContractStandard": "Velg kontraktstandard",
        "suggestsStandard": "Volve foreslår {name}.",
        "addReferenceFile": "Legg til et underlag eller en standard",
        "uploadStandards": "Last opp flere standarder",
        "missingStandards": "{count, plural, one {Foreslår # standard til} other {Foreslår # standarder til}}",
        "upload": "Last opp",
        "alwaysIncluded": "Uansett valg følger kravene med sidehenvisning og rammebetingelsene med pakken.",
        "continue": "Gå videre",
        "makeDescription": "Lag beskrivelse",
        "backToRequirements": "Tilbake til krav",
        "selectedPackages": "Valgte pakker",
        "chooseMethod": "Velg beskrivelsesmåte",
        "methodsFromStandard": "Valgene kommer fra standarden du valgte. Gjelder de {count} valgte pakkene.",
        "combine": "Slå sammen",
        "combineUnavailable": "Sammenslåing av kapitler er ikke tilgjengelig ennå.",
        "makeDescriptions": "Lag beskrivelse ({count})",
        "makeDescriptionsHint": "Lager beskrivelse for de valgte pakkene i bakgrunnen. Pakker uten beskrivelsesmåte spør først.",
        "addChapter": "Legg til kapittel",
        "combineTitle": "Slå sammen {count} pakker",
        "combineBody": "Kravene i {others} flyttes til {target}. Pakker som blir tomme, skjules.",
        "chaptersTitle": "Kapitler",
        "workPackChoice": "Arbeidspakke · velg nå eller senere",
        "packagesWord": "{count, plural, one {pakke} other {pakker}}",
        "suggestionsWord": "forslag",
        "conflictsWord": "{count, plural, one {konflikt} other {konflikter}}",
        "mergeTitle": "Kjøpes vanligvis samlet",
        "mergeNote": "Ingenting slås sammen uten at du velger det. Kapittelet i standarden styrer fortsatt kodene.",
        "conflictCount": "{count, plural, one {# konflikt} other {# konflikter}}",
        "outsideRequirements": "{count} krav utenfor standarden",
        "outsidePackages": "fordelt på {count, plural, one {# pakke} other {# pakker}}: {names}",
        "milestones": {
          "requirements": "Krav sjekket",
          "method": "Beskrivelsesmåte valgt",
          "described": "Beskrevet",
          "sent": "Sendt"
        },
        "previewCount": "Krav i pakken · viser {shown} av {count}",
        "conditionsFound": "Volve fant {count, plural, one {# rammebetingelse} other {# rammebetingelser}} i konkurransegrunnlaget som gjelder pakken. {included} er tatt med.",
        "noConditionsFound": "Volve fant ingen rammebetingelser i konkurransegrunnlaget som gjelder pakken.",
        "includeAll": "Ta med alle",
        "includeInPack": "Ta med i pakken",
        "openPdf": "Åpne PDF",
        "scopeShort": {
          "manual": "Manuelt",
          "exact": "Eksakt",
          "paragraph": "Avsnitt",
          "section": "Del av kapittel",
          "chapter": "Hele kapittelet",
          "document": "Hele dokumentet"
        },
        "chooseScope": "Velg omfang",
        "chooseOne": "Velg én.",
        "scopeOptions": {
          "manual": "Bruk teksten som er markert manuelt",
          "exact": "Bare det markerte",
          "paragraph": "Utvid til avsnitt",
          "section": "Utvid til del av kapittel",
          "chapter": "Utvid til kapittel",
          "document": "Ta med hele dokumentet"
        },
        "scopeOptionHints": {
          "manual": "Teksten som er markert manuelt tas med.",
          "exact": "Bare den markerte teksten tas med.",
          "paragraph": "Hele avsnittet rundt teksten tas med.",
          "section": "Bare {number}. Den siterte delen tas med.",
          "chapter": "Hele kapittelet {number} hører til.",
          "document": "Hele {document} som vedlegg."
        },
        "remove": "Fjern",
        "paragraphs": "{count, plural, one {# avsnitt} other {# avsnitt}}",
        "riggingGroup": "{chapter} · {count} {lines} som allerede er med under Poster, vises ikke",
        "include": "Ta med",
        "otherLines": "Andre {lines}",
        "uploadQuantities": "Last opp liste og mengder",
        "uploadQuantitiesHint": "Velg en fil fra anbudet. Volve foreslår hvilke {lines} mengdene hører til.",
        "citation": "Sitat",
        "marked": "Markert:",
        "postsLabel": "Poster",
        "contractStandard": "Kontraktsstandard",
        "basis": "Underlag",
        "basisPages": "{pages, plural, one {# side} other {# sider}} fra {documents, plural, one {# dokument} other {# dokumenter}}",
        "sendTitle": "Send {name}",
        "companyPlaceholder": "Firmanavn",
        "emailPlaceholder": "navn@firma.no",
        "deadlineShort": "frist {date}",
        "sendVersion": "Send versjon {version}",
        "startSubtitle": "{project} · velg hva omfangsoversikten skal starte fra.",
        "clientDescription": "Byggherrens beskrivelse",
        "clientRequirements": "Byggherrens krav",
        "foundContractStructure": "Fant kontraktsstandard <b>{standard}</b>, {chapters} kapitler og {lines} {term}.",
        "foundContractOnly": "Fant kontraktsstandard <b>{standard}</b>."
      },
      "review": {
        "manualHint": "Marker teksten i dokumentet til høyre, og bruk markeringen.",
        "manualEmpty": "Marker tekst i dokumentet først.",
        "useSelection": "Bruk markeringen",
        "cancelMarking": "Avbryt",
        "markNewText": "Marker ny tekst",
        "startsNow": "Starter med en gang. Du ser fremdriften i neste steg.",
        "describingTitle": "Mens beskrivelsen lages",
        "describingLocked": "Valgene er låst til beskrivelsen er ferdig.",
        "seeProgress": "Se fremdrift",
        "standardProcessing": "Leses inn…",
        "standardFailed": "Kunne ikke leses",
        "standardReady": "Klar",
        "standardProcessingHint": "Volve venter med å bruke en standard til den er lest inn. Du kan gå videre i mellomtiden.",
        "describeFailed": "Beskrivelsen ble ikke ferdig",
        "retry": "Prøv igjen",
        "describingHeading": "Volve lager beskrivelsen",
        "queued": "I kø",
        "queuedAt": "I kø · nr. {position}",
        "queuedHint": "Starter når pakkene foran i køen er ferdige.",
        "percent": "{value} %",
        "progressLabel": "Fremdrift",
        "describingHint": "Du kan gå til andre pakker imens. Dette steget oppdateres av seg selv.",
        "stages": {
          "reading": "Leser kravene",
          "summary": "Sammendrag",
          "interfaces": "Grensesnitt",
          "conditions": "Rammebetingelser",
          "lines": "Poster",
          "quantities": "Mengder",
          "finishing": "Ferdigstiller"
        },
        "errors": {
          "source_not_ready": "En kilde ({document}) er ikke lest inn ennå. Prøv igjen om litt, eller last opp selv.",
          "source_missing": "En kilde ({document}) finnes ikke lenger i arbeidsområdet.",
          "level_not_read": "Et krav peker på et kildenivå Volve ikke har lest. Velg et annet nivå på kravet.",
          "execution_missing": "Velg egen utførelse eller underentreprise først.",
          "description_busy": "Beskrivelsen lages nå. Prøv igjen når den er ferdig.",
          "build_busy": "Noe annet i pakken lages nå. Prøv igjen når det er ferdig.",
          "worker_failed": "Noe gikk galt hos Volve. Prøv igjen."
        },
        "draftTitle": "Foreløpig pakke",
        "draftBadge": "Utkast",
        "draftMeta": "{title} · beskrivelse + {count, plural, one {# krav} other {# krav}} · utkast, ikke sendt",
        "draftDownloadFailed": "Kunne ikke laste ned utkastet.",
        "draftFileName": "Utkast {title}",
        "draftFailed": "Kunne ikke vise utkastet. Prøv igjen.",
        "draftStamp": "UTKAST",
        "draftIntroduction": "Innledning",
        "draftInterfaces": "Grensesnitt mot andre pakker",
        "draftConditions": "Rammebetingelser",
        "draftPage": "s. {page}",
        "attachedHint": "{name} er lagt ved pakken",
        "merge": "Slå sammen til én PDF",
        "mergeWaiting": "Venter på {count, plural, one {# dokument} other {# dokumenter}}",
        "mergeFailed": "Sammenslåingen ble ikke ferdig: {reason}",
        "workPackRow": "Arbeidspakken",
        "workPackFile": "Teknisk beskrivelse {name}",
        "workPackMeta": "Beskrivelse + {count, plural, one {# krav} other {# krav}}",
        "generated": "Generert",
        "previewAction": "Forhåndsvis",
        "download": "Last ned utkast (PDF)",
        "slotWriting": "Volve skriver dokumentet…",
        "slotLocked": "Du kan jobbe med de andre dokumentene imens",
        "slotFailed": "Kunne ikke generere: {reason}",
        "removedRequirements": "{count, plural, one {# krav} other {# krav}} fjernet fra pakken",
        "removeFromPackage": "Fjern fra pakken",
        "citationScopeSummary": "Kilde: <strong>{level}</strong>",
        "contractScopeSummary": "Med i kontrakten: <strong>{level}</strong>",
        "contractScopeHint": "Volve setter disse for hvert krav. Kilde bestemmer hvor mye tekst som vises; med i kontrakten bestemmer hva som tas med i arbeidspakken.",
        "hide": "Skjul",
        "change": "Endre",
        "outsideHint": "Kravene passet ikke inn i noen post i standarden. Volve har samlet dem i egne pakker. Åpne en pakke for å flytte krav til riktig sted.",
        "requirementCount": "{count, plural, one {# krav} other {# krav}}",
        "open": "Åpne",
        "needsInput": "Trenger input",
        "enter": "Angi",
        "quantity": "Mengde",
        "questionTitle": "Volve trenger svar før posten kan mengdes",
        "updateLine": "Oppdater posten",
        "inputSummary": "{fields, plural, one {# felt} other {# felt}} trenger input, fordelt på {lines, plural, one {# post} other {# poster}}",
        "legendKnown": "Fra dokumentene",
        "legendAssumption": "Antakelse fra Volve",
        "legendInput": "Trenger input",
        "answerFirst": "Svar først",
        "movedOut": "{count, plural, one {# krav} other {# krav}} flyttet til «{name}». {lines, plural, =0 {Ingen poster ble fjernet.} one {# post som bare dekket disse kravene er fjernet herfra.} other {# poster som bare dekket disse kravene er fjernet herfra.}}",
        "dismiss": "Lukk",
        "movedIn": "{count, plural, one {# krav} other {# krav}} flyttet hit. Volve skriver og mengder nye poster for dem.",
        "showFullText": "Vis hele teksten",
        "volveSuggestion": "Volves forslag",
        "rolesTitle": "Roller i teksten",
        "rolesHint": "Kravene er skrevet fra byggherre (BH) til totalentreprenør (TE). Hvordan skal de leses av underentreprenøren?",
        "rolesRewrite": "Skriv om kravene.",
        "rolesRewriteHint": "TE blir UE og BH blir TE i all kravtekst. Originalteksten vises ved klikk.",
        "rolesIntro": "Behold originalteksten.",
        "rolesIntroHint": "Innledningen får setningen: «Der det står TE, er UE ansvarlig for å levere. Der det står BH, menes TE.»",
        "showOriginal": "Vis original",
        "showRewritten": "Vis omskrevet",
        "removedList": "Fjernet fra pakken ({count})",
        "restore": "Gjenopprett",
        "mergeNothing": "Alle dokumenter er merket ikke relevant"
      }
    },
    "sheets": {
      "empty": "Arket har ingen faner ennå",
      "editorUnavailable": "Samtidig redigering er utilgjengelig. Viser siste lagrede versjon.",
      "review": "Vurdering",
      "inputErrors": {
        "number": "Skriv inn et tall",
        "option": "Velg et av kolonnens valg",
        "reference": "Referanser kommer fra agenten og kan ikke skrives inn"
      },
      "unknownDocument": "Dokument",
      "page": "Side {page}",
      "columnTypes": {
        "text": "Tekst",
        "number": "Tall",
        "enum": "Valg",
        "date": "Dato",
        "reference": "Referanse"
      },
      "save": "Lagre",
      "rowNumber": "Rad {number}",
      "undo": "Angre",
      "redo": "Gjør om",
      "download": "Last ned (.xlsx)",
      "downloadError": "Kunne ikke laste ned arket. Prøv igjen.",
      "tabFallback": "Fane {number}",
      "openRow": "Åpne raddetaljer og kommentarer",
      "editRefused": "Endringen ble ikke gjort",
      "unsavedRow": "Ikke lagret",
      "unsavedRowDescription": "Lagre nye rader før du vurderer dem eller oppretter oppgaver for dem",
      "saveRows": "Lagre {count, plural, one {ny rad} other {# nye rader}}",
      "saveError": "Kunne ikke lagre arket. Prøv igjen.",
      "sources": "Kilder",
      "sheetInScopeBreakdown": "Dette arket er omfangsoversikten",
      "sheetInScopeBreakdownDescription": "Se og rediger det i arbeidsområdets omfangsoversikt.",
      "openScopeBreakdown": "Åpne omfangsoversikt"
    },
    "packageSharing": {
      "recipients": "Mottakere",
      "offers": "Tilbud",
      "addRecipient": "Legg til mottaker",
      "updateRecipients": "Oppdater mottakere",
      "noRecipients": "Ingen mottakere ennå.",
      "anyRecipient": "Lenkemottaker",
      "version": "Versjon {version}",
      "deadline": "Tilbudsfrist {date}",
      "activity": "{visits} besøk · {downloads} nedlastinger · {questions} spørsmål · {offers} tilbud",
      "revoke": "Trekk tilbake lenken",
      "revoked": "Trukket tilbake",
      "sendTitle": "Send {name}",
      "sendExplanation": "Versjon {version} låses når du deler. Hver mottaker får sin egen lenke og trenger ikke logge inn. Volve sender ikke invitasjoner.",
      "company": "Firma (valgfritt)",
      "email": "E-post",
      "offerDeadline": "Tilbudsfrist",
      "expiry": "Lenken utløper (valgfritt)",
      "expiryHint": "Som standard 30 dager etter tilbudsfristen.",
      "add": "Legg til",
      "remove": "Fjern",
      "download": "Last ned",
      "chat": "Spør om pakken",
      "upload_offer": "Last opp tilbud",
      "shareLink": "Delingslenke",
      "copy": "Kopier",
      "copied": "Kopiert",
      "emailDraft": "Utkast til e-post",
      "draftBody": "Se gjennom {name} og lever tilbudet via denne lenken: {url}",
      "shownOnce": "Kopier lenken nå. Den vises ikke igjen etter at du forlater siden.",
      "generateFirst": "Generer arbeidspakken før du sender den.",
      "close": "Lukk",
      "sendVersion": "Send versjon {version}",
      "limitError": "Bruksgrensen er nådd. Prøv igjen senere eller kontakt avsenderen.",
      "verifyError": "Bekreft e-postadressen din før du fortsetter.",
      "linkError": "Lenken er utilgjengelig, utløpt eller trukket tilbake. Kontakt avsenderen.",
      "error": "Handlingen kunne ikke fullføres. Prøv igjen eller kontakt avsenderen.",
      "unavailable": "Pakken er utilgjengelig",
      "requestForOffer": "Forespørsel om tilbud",
      "overview": "Oversikt",
      "conditions": "Rammebetingelser",
      "items": "Krav",
      "drawings": "Tegninger",
      "documents": "Dokumenter",
      "about": "Om pakken",
      "allConditions": "Se alle {count} betingelser",
      "contents": "Innhold",
      "counts": "{items} {itemLabel} og {pages} sider fra underlaget",
      "contact": "Kontakt",
      "contract": "Kontrakt",
      "madeWith": "Utarbeidet med Volve.",
      "tryVolve": "Prøv det på dine egne anbud",
      "uploadOffer": "Last opp tilbud",
      "view": "Vis",
      "ask": "Spør om pakken",
      "chatBoundary": "Svarene bygger bare på dokumentene i pakken.",
      "question": "Skriv et spørsmål",
      "answering": "Svarer…",
      "send": "Send",
      "verifyTitle": "Bekreft e-postadressen",
      "verifyHelp": "En engangskode kreves før det første spørsmålet eller opplastingen. Det opprettes ingen konto.",
      "sendCode": "Send kode",
      "code": "Engangskode",
      "verify": "Bekreft",
      "offerReceived": "Tilbudet ditt er mottatt.",
      "scanning": "Tilbudet er privat mens skanningen etter skadevare pågår.",
      "checkScan": "Sjekk skannestatus",
      "updated": "Avsenderen har oppdatert pakken. Endret:",
      "changed": {
        "summary": "Sammendrag",
        "introduction": "Innledning",
        "interfaces": "Grensesnitt",
        "items": "Poster og krav",
        "conditions": "Betingelser",
        "sections": "Dokumentdeler",
        "delivery_matrix": "Leveransematrise",
        "files": "Filer"
      },
      "deliveryMatrix": "Leveransematrise",
      "interfaces": "Grensesnitt",
      "settings": "Delingsinnstillinger",
      "enabled": "Tillat ekstern deling",
      "requireEmail": "Krev mottakerens e-post",
      "allowChat": "Tillat spørsmål om pakken",
      "maxExpiry": "Maksimal levetid for lenker (dager)",
      "dailyQuestions": "Spørsmål per lenke per dag",
      "dailyCost": "Kostnadsgrense per lenke per dag (USD)",
      "save": "Lagre",
      "contactConsent": "Jeg samtykker til at Volve beholder kontaktinformasjonen min for oppfølging.",
      "resendCode": "Be om en ny kode",
      "linkActivity": "Lenkeaktivitet",
      "clarifyQuestion": "Opprett avklaring",
      "clarificationCreated": "Avklaring opprettet",
      "activityRecorded": "Aktivitet registrert",
      "guestRetention": "Behold gjestedata etter utløp (dager)",
      "firstOpened": "Først åpnet {date}",
      "lastOpened": "Sist åpnet {date}",
      "botUnavailable": "Bekreftelse er ikke tilgjengelig. Prøv igjen.",
      "openOffer": "Åpne tilbudsfiler",
      "expiryRequired": "Velg en utløpsdato senest {date}.",
      "copyFailed": "Kunne ikke kopiere. Marker og kopier lenken manuelt.",
      "chatGreeting": "Spørsmål om pakken?",
      "chatStarters": [
        "Hva omfatter pakken?",
        "Hvilke frister og dagmulkter gjelder?",
        "Hva må tilbudet inneholde?"
      ]
    }
  },
  "pages": {
    "subcontractorBids": {
      "settings": {
        "disciplines": "Krav"
      },
      "createProcurement": {
        "description": "Definer en anskaffelsespakke ut fra kravene for å samle inn og sammenligne underleverandørtilbud.",
        "steps": {
          "disciplines": "Krav"
        }
      }
    }
  },
  "components": {
    "workPackages": {
      "tender": {
        "wizard": {
          "description": "Velg krav som skal flyttes til arbeidspakken, eller la den være tom.",
          "scopeCount": "{count, plural, =1 {# krav} other {# krav}}",
          "createdToast": "Arbeidspakke opprettet",
          "name": "Navn på arbeidspakke",
          "loadFailed": "Kunne ikke laste krav",
          "retry": "Prøv igjen",
          "empty": "Ingen krav tilgjengelig ennå",
          "rest": "Restomfang",
          "requirements": "Krav"
        }
      }
    }
  }
}
